<ng-template #header>
    <div class="modal-for-add-voucher__inner">
        <shared-header [center]="false" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
                       class="modal-for-add-voucher__sub-h">
            {{preTitle}}
        </shared-header>

        <shared-header [center]="false" class="modal-for-add-voucher__h" type="3" marginTop="none" marginBottom="none">
            {{title}}
        </shared-header>

        <shared-text class="modal-for-add-voucher__desc" [brandAccent]="false" [dimmed]="true" weight="300">
            <div class="modal-for-add-voucher__desc-item" *ngFor="let desc of description">
                {{desc}}
            </div>
        </shared-text>
    </div>
</ng-template>

<shared-modal-type-dynamic-height [header]="header" [footer]="footer" [headerBorderBottom]="false"
    [modalData]="modalData" [center]="false" [footerBorder]="false" [mobilePreserve]="true" [size]="'sm'"
    (onScrollInit)="handleScrollInit($event)" (onCloseClick)="handleCloseClick($event)" class="modal-for-add-voucher">

    <shared-form-for-add-voucher (onInit)="handleFormInit($event)" class="modal-for-add-voucher__form">
    </shared-form-for-add-voucher>

</shared-modal-type-dynamic-height>

<ng-template #footer>
    <div class="modal-for-add-voucher__ft">
        <shared-btn size="lg" type="button" [emphasis]="false"
            (onClick)="handleAddVoucherClick()" [disabled]="!isFormValid"
            [loading]="(voucherLoading$ | async)">
            Apply
        </shared-btn>
    </div>
</ng-template>
